<template>
    <div class="container wrapper" :class="[state.mouseClass, state.fadeClass, state.visibilityClass]">
        <div class="split">
            <Tip class="tiptemporary" v-if="!state.backToStart && props.showInfo" :tipMsg="state.tipMsg[state.tipIndex]" :mood="state.tipMood" />
            <div class="splitContainer">
                <div class="card" v-if="!state.backToStart" :class="[state.cardFade]">
                    <div id="cardElement">
                        <Card :description="state.currentCard.description"/>
                    </div>
                    <p class="unselectable">Kortteja jäljellä: {{ decks[props.chosenDeck].cards.length - state.cardsDrawn }}</p>
                </div>
                <div class="content temporary">
                    <div v-if="!state.backToStart" class="helpText">
                    <p class="unselectable pHelp"><span class="bold">Voimavarat </span>ovat asioita, joista koet saavasi voimaa ja jotka auttavat sinua elämässäsi.</p>
                    <p class="unselectable pHelp"><span class="bold">Toiveilla </span>tarkoitetaan asioita ja ominaisuuksia, joita toivoisit saavuttavasi elämäsi aikana. Toiveet voivat olla myös asioita, joita sinulla jo elämässäsi on ja joiden toivoisit elämässäsi säilyvän.</p>
                    <p class="unselectable pHelp"><span class="bold">Haaste </span>on asia, joka koet tällä hetkellä elämässäsi haastavana. Haasteet voidaan kokea myös positiivisina asioina, jos ne esimerkiksi saavat sinut toimimaan tehokkaammin.</p>
                    <p class="unselectable pHelp"><span class="bold">Ongelmat </span>ovat selkeästi asioita, joihin tulee saada selkeä ratkaisu ja joiden ratkaisemisessa voidaan tarvita ulkopuolista apua.</p>
                    </div>
                </div>
                <div class="startOverMessage" v-if="state.backToStart">
                    <p>Valitse kategorioihin <b>HAASTE</b>, <b>TOIVE</b> ja <b>ONGELMA</b> yhteensä vähintään 2 korttia
                    ja kategoriaan <b>VOIMAVARA</b> vähintään 2 korttia, jotta saamme keskustelusta mahdollisimman
                    kattavan.</p>
                    <button class="btn" @click="startOver">Takaisin alkuun</button>
                </div>
            </div>
        </div>
        <div class="split">
            <div v-if="!state.backToStart" class="content">
                <img class="background-image" src="../assets/alusta.png" alt="Trigenda-triangle">
                <div class="trigendaBoard-container buttons">
                    <div id="trigendaBoard" :class="[state.triangleFade]">
                        <div class="first">
                            <div>
                                <div
                                    @mouseover="hover1 = true"
                                    @mouseleave="hover1 = false"
                                    class="triangle" @click="saveSelection('Voimavara')">
                                </div>
                            </div>
                        </div>
                        <div>
                            <div
                                @mouseover="hover2 = true"
                                @mouseleave="hover2 = false"
                                class="triangle" @click="saveSelection('Haaste')">
                            </div>
                        </div>
                        <div>
                            <div
                                @mouseover="hover3 = true"
                                @mouseleave="hover3 = false"
                                class="triangle" @click="saveSelection('Toive')">
                            </div>
                        </div>
                        <div>
                            <div
                                @mouseover="hover4 = true"
                                @mouseleave="hover4 = false"
                                class="triangle" @click="saveSelection('Ongelma')">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="trigendaBoard-container backgrounds">
                    <div id="trigendaBoard" :class="[state.triangleFade]">
                        <div class="first">
                            <div>
                                <div
                                :class="{ highlight: hover1 }"
                                class="triangle-background"></div>
                            </div>
                        </div>
                        <div>
                            <div
                            :class="{ highlight: hover2 }"
                            class="triangle-background"></div>
                        </div>
                        <div>
                            <div
                            :class="{ highlight: hover3 }"
                            class="triangle-background"></div>
                        </div>
                        <div>
                            <div
                            :class="{ highlight: hover4 }"
                            class="triangle-background"></div>
                        </div>
                    </div>
                </div>
            <button @click="saveSelection('EnOsaaSanoa')" class="btn" id="next">En osaa sanoa</button>
            </div>
        </div>
    </div>
</template>

<script>
import Card from "./Card.vue";
import decks from "../decks.json";
import Tip from '../components/Tip.vue';
import {reactive} from "vue";

export default {
    name: 'Phase1',
    components: {
        Card,
        Tip
    },
    data() {
        return {
            hover1: false,
            hover2: false,
            hover3: false,
            hover4: false,
        }
    },
    props: {
        // Index of the chosen deck in decks.json
        chosenDeck: Number,
        showInfo: Boolean
    },
    setup(props, {emit}) {
        localStorage.removeItem("cardArray");
        localStorage.removeItem("feedbackCards");
        localStorage.removeItem("summaryAnswers");
        localStorage.removeItem("deckInfo");

        /**
         * Constant state is made a reactive object, which means when you change it's
         * properties, the changes show reactively in the template as well.
         *
         * if backToStart is true, the message to choose at least total of 2 cards in
         * Challenge, Wish and Problem cards and total of 2 cards in Asset cards is shown at
         * the end of Phase 1.
         *
         * tipMsg and tipMood are passed as props to Tip component to show a message and set
         * Tringo's mood. Mood can be 'happy', 'confused' or 'sad'.
         * tipIndex tells which message will be passed to Tip component from tipMsg array.
         */
        const state = reactive({
            // How many cards have the user gone through
            cardsDrawn: 0,
            // Card that is currently showing
            currentCard: decks[props.chosenDeck].cards[0],
            // Fade effect CSS class for Container div. ('fadeIn' or 'fadeOut')
            fadeClass: null,
            // Visibility CSS class for Container div. ('visible' or 'hidden')
            visibilityClass: 'hidden',

            /**
             * Mouse CSS class for Container div,
             * tells if mouse clicks are enabled or disabled. ('mouseEnabled' or 'mouseDisabled')
             */
            mouseClass: 'mouseDisabled',
            backToStart: false,
            tipMsg: [
                ['Aloitetaan työskentelyn ensimmäinen vaihe. Sijoita vasemmalla oleva käsitekortti siihen sektoriin, johon se mielestäsi kuuluu. Ole rohkea ja uskalla tarttua ensimmäiseen ajatukseen, joka mieleesi nousee - eli luota intuitioon! Käsitteet voivat liittyä elämääsi ja elämäsi eri osa-alueisiin myös muiden henkilöiden tai asioiden kautta.'],
                ['Jatka käsitekorttien lajittelua yksi kortti kerrallaan. Mikäli tietty käsite ei miettimisen jälkeen synnytä mielikuvaa ja kortti ei mielestäsi kuulu mihinkään, voit valita “en osaa sanoa”.']
            ],
            tipIndex: 0,
            tipMood: 'happy',
        });

        const fadeInElements = () => {
            state.fadeClass = 'fadeIn'
            state.visibilityClass = 'visible'
            setTimeout(() => {
                state.mouseClass = 'mouseEnabled';
            }, 200);
        }

        const fadeOutElements = () => {
            state.fadeClass = 'fadeOut'
            state.mouseClass = 'mouseDisabled';
            setTimeout(() => {
                emit("phasecomplete");
            }, 200);
        }
        fadeInElements();

        /**
         * Function saveSelection saves the current card
         * and where the user placed the card in the browser's localStorage.
         * !! THIS WILL BE CHANGED LATER TO SAVE THE INFORMATION TO DATABASE !!
         *
         */
        const saveSelection = (selection) => {
            if (state.tipIndex < 1)
                state.tipIndex++;

            const saveData = {...state.currentCard, phase1selection: selection};
            let cardArray = [];

            if (localStorage.getItem("cardArray"))
                cardArray = JSON.parse(localStorage.getItem("cardArray"));

            cardArray.push(saveData);
            localStorage.setItem("cardArray", JSON.stringify(cardArray));

            if (state.cardsDrawn == decks[props.chosenDeck].cards.length - 1) {

                /**
                 * If all the cards have been saved, show Fade out effect and
                 * emit 'phasecomplete' to the parent component to get to the next phase
                 */
                const phaseSuccessful = checkIfPhaseSuccessful();
                if (phaseSuccessful)
                    fadeOutElements();
                else
                    state.backToStart = true;
            }

            state.cardsDrawn++;
            // Set next card to be current card if there are cards left in the deck
            if (state.cardsDrawn < decks[props.chosenDeck].cards.length)
                state.currentCard = decks[props.chosenDeck].cards[state.cardsDrawn];
        }

        const checkIfPhaseSuccessful = () => {

            /**
             * When there are no cards left, check if there are total of 2 cards
             * in Challenge, Wish and Problem cards and total of 2 cards in
             * Asser cards. If so, continue to Phase 2, otherwise start over Phase 1.
             */
            let challengeWishProblemCount = 0;
            let assetCount = 0;
            const cardArray = JSON.parse(localStorage.getItem('cardArray'));

            /**
             * Count total cards in Challenge, Wish and Problem cards.
             * Count total cards in Asset cards.
             */
            cardArray.forEach(card => {
                if (card.phase1selection === 'Haaste' ||
                    card.phase1selection === 'Toive' ||
                    card.phase1selection === 'Ongelma')
                    challengeWishProblemCount++;
                else if (card.phase1selection === 'Voimavara')
                    assetCount++;
            });

            if (challengeWishProblemCount < 2 || assetCount < 2)
                return false;
            else
                return true;
        }

        const startOver = () => {
            localStorage.removeItem("cardArray");
            state.cardsDrawn = 0;
            state.currentCard = decks[props.chosenDeck].cards[0];
            state.backToStart = false;
            state.tipIndex = 0;
        }

        const saveDeckInfo = () => {
            const deckInfo = {
                name: decks[props.chosenDeck].name,
                type: decks[props.chosenDeck].type,
                language: decks[props.chosenDeck].language
            }

            localStorage.setItem("deckInfo", JSON.stringify(deckInfo));
        }

        saveDeckInfo();

        return { decks, state, saveSelection, startOver, checkIfPhaseSuccessful, fadeOutElements, props, saveDeckInfo };
    },
    emits: ['phasecomplete'],
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
    .wrapper {
        display: flex;
        height: 90vh;
    }

    .unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    }

    .pHelp {
        padding: 0 0 1em 0;
    }

    .split {
        width: 50%;
        height: 89.1vh;
        justify-content: center;
        padding: 10px;
    }

    .split div {
        position: relative;
    }

    .split .splitContainer {
        top: 17%;
    }

    .split.split:nth-child(2) .content {
        margin-top: 130px;
    }

    .split:nth-child(2) {
        background-image: url('../assets/tausta_blue.jpg');
        background-size: cover;
        background-repeat: no-repeat;
    }
    .split:first-child {
        background-color: var(--left);
    }

    .card {
        margin-top: 40px;
        margin-bottom: 70px;
    }

    .helpText {
        text-align: left;
        margin: 0 auto;
        margin-top: -2vw;
        width: 80%;
        /*overflow-y: scroll;*/
        overflow-y: scroll;
        max-height: 11em;
    }

    .helpText p {
        margin: 2px 0;
    }

    .mouseDisabled {
        pointer-events: none;
    }

    .mouseEnabled {
        pointer-events: auto;
    }

    .background-image {
        position: relative;
        width: 459px;
        z-index: 30;
        user-select: none;
    }

    .trigendaBoard-container {
        position: absolute !important;
        z-index: 30;
        top: 0;
        width: 100%;
        height: 90%;
    }

    #trigendaBoard {
        position: relative;
        width: 459px;
        height: 400px;
        margin: 30px auto;
        display: flex;
        flex-wrap: wrap;
    }

    #trigendaBoard div {
        padding: 10px;
        width: 130px;
        height: 135px;
        margin: auto;
    }

    #trigendaBoard div:nth-child(1) {
        width: 100%;
        margin: auto;
        padding: 0 30px;
    }

    #trigendaBoard div:nth-child(1) div {
        width: 90px;
    }

    .triangle {
        clip-path: polygon(50% 0%, 10% 100%, 90% 100%);
        position: absolute !important;
        margin: 0 !important;
        width: 100% !important;
        height: 100% !important;
        top: -10px !important;
        left: -30px !important;
        transition: 250ms background-color ease;
        cursor: pointer;
    }

    .triangle-background {
        clip-path: polygon(50% 0%, 0% 90%, 100% 90%);
        position: absolute !important;
        background-color: var(--white);
        margin: 0 !important;
        width: 70% !important;
        height: 100% !important;
        top: -10px !important;
        left: -10px !important;
        transition: background-color 250ms ease;
    }

    .backgrounds #trigendaBoard div:nth-child(1) div {
        transform: translateY(-12px);
    }

    .backgrounds #trigendaBoard div:nth-child(3) div {
        transform: rotate(180deg) translateY(30px) translateX(-5px) scale(1.1);
    }

    .backgrounds {
        z-index: 1;
    }

    .buttons {
        z-index: 50;
    }

    #trigendaBoard div:nth-child(1) div {
        transform: translateY(-17px);
    }

    #trigendaBoard div:nth-child(2) div {
        transform: translateX(28px) scaleX(1.05);
    }

    #trigendaBoard div:nth-child(3) div {
        transform: rotate(180deg) translateY(30px);
    }

    #trigendaBoard div:nth-child(3) .triangle {
        transform: rotate(180deg) translateY(10px);
    }

    #trigendaBoard div:nth-child(4) div {
        transform: translateX(-28px) scaleX(1.05);
    }

    /*.triangle:hover, .triangle:active {
        background-color: var(--btn_hover);
        opacity: 0;
    }*/

    .highlight {
        background-color: var(--btn_hover);
    }

    button {
        display: block;
        margin: 30px auto;
        margin-bottom: 0px;
    }

    /*
    700px mobile break point
    */

    @media only screen and (max-width: 700px) {
        .wrapper {
            flex-direction: column;
        }

        .split {
            width: 96%;
        }

        .temporary {
            display: none;
        }

        .wrapper {
            height: 91vh;
        }

        .split:nth-child(2) .content {
            margin-top: 0px !important;
        }

        #trigendaBoard {
            margin-top: 5px;
            margin-bottom: 10px;
            transform: scale(1) translate(1px, 25px);
        }
    }
        @media only screen and (max-width: 1000px) {
        .content {
            transform: scale(0.8);
        }
    }
        @media only screen and (max-width: 850px) {
        .content {
            transform: scale(0.6);
        }
    }

      /*
      Mobile media points -> translateX for board position -> Button margin-left for button position
      */


    @media only screen and (max-width: 480px) {
        .content {
            transform: scale(0.6) translateX(-2vw);
        }
        button {
            margin-left: 30vw;
        }
    }
        @media only screen and (max-width: 400px) {
        .content {
            transform: scale(0.6) translateX(-10vw) translateY(-100px);
        }
        button {
            margin-left: 30vw;
        }
    }
        @media only screen and (max-width: 360px) {
        .content {
            transform: scale(0.6) translateX(-15vw);
        }
        button {
            margin-left: 35vw;
        }
    }
         @media only screen and (max-width: 340px) {
        .content {
            transform: scale(0.6) translateX(-25vw);
        }
        button {
            margin-left: 40vw;
        }
    }
</style>
